import React from "react";

export const Minus = () => (
<svg
  width="32"
  height="32"
  viewBox="0 0 32 32"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M20 16H12"
    stroke="currentColor"
    strokeWidth="1.6"
    strokeMiterlimit="10"
    strokeLinecap="round"
  />
</svg>
);
